import GlobalDataFactory from '../factories/GlobalDataFactory';
import GetGlobalDataResult from '../models/GetGlobalDataResult';
import type { OrderPageMode } from '@/presentation/constants/OrderPageModeConstants';

export default class GetGlobalDataUseCase {
    private globalDataRepo = GlobalDataFactory.makeRepo();

    public async invoke(mode: OrderPageMode, productId: number, ref: string) {
        let result = new GetGlobalDataResult();
        const getDataResult = await this.globalDataRepo.get(mode, productId, ref);
        if (getDataResult.customResponseCode) {
            result.customResponseCode = getDataResult.customResponseCode;
        }
        if (getDataResult.success === false) {
            result = result.copyExceptData(getDataResult);
            return result;
        }

        const customerSourceId = Number(getDataResult.data?.customerSourceId);
        if (Number.isFinite(customerSourceId) && customerSourceId > 0) {
            result.customerSourceId = Math.floor(customerSourceId);
            result.data.customerSourceId = result.customerSourceId;
            result.data.customerInfo = getDataResult.data?.customerInfo || null;
            result.data.products = getDataResult.data?.products || [];
            const pct = Math.floor(Number(getDataResult.data?.qrDiscountPercent));
            result.qrDiscountPercent = Number.isFinite(pct) && pct >= 0 ? Math.min(pct, 100) : 0;
            result.data.qrDiscountPercent = result.qrDiscountPercent;
        } else {
            result.customerSourceId = null;
            result.message = String(getDataResult.message || 'customerSourceId invalid');
            return result;
        }

        result.success = true;
        if (getDataResult.message) {
            result.message = getDataResult.message;
        }
        return result;
    }
}
